export default "__VITE_ASSET__UXy7mDzE__"